/**
 * Created by Mark on 17/04/2017.
 */


import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Actions from '../application-actions.js';

class LessonPlanService {

    constructor(){

    }

    getAll(){

        return ApplicationServices.call(Constants.ALL_LESSONS , {}).then(function(response){
            Actions.update(Constants.ALL_LESSONS , response.plans);
        });

    }

}


export default new LessonPlanService();